import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledSearchFormExpandedMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: ${color.base20};

  .field-row {
    margin-bottom: ${toRem(16)};
    input {
      height: ${toRem(56)} !important;
    }
  }
`;

export const StyledExpandedForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`;

export const StyledFooter = styled.div`
  padding: ${toRem(16)} 0;
  margin-top: auto;
  button {
    width: 100%;
    height: ${toRem(48)};
  }
`;
